import axios from 'axios';

export default {
    download() {
        return axios.download('/api/canadiantaxes/export');
    },
    getTaxes() {
        return axios.get('/api/canadiantaxes');
    },
    updateTaxForState(stateId, value) {
        return axios.put('/api/canadiantaxes/' + stateId, value);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/masters/canadiantaxes/api.js